import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import { NgClass, NgIf, DecimalPipe } from '@angular/common';
import { CountToDirective } from '../../editors/count-to-directive/count-to.directive';
import { DurationPipe } from '../../core/pipes/duration.pipe';

@Component({
    selector: 'app-dashboard-card',
    template: `
    <div class="dashboard-stats__item" [style.background]="backgroundColor"
         [class.stats-item-active]="filterType == selectedFilterType.action" (click)="onCubicClick($event)">
      <div class="icon-group">
        <i class="fa fa-phone"></i>
        <i class="fa second" [ngClass]="secondIconClass"></i>
      </div>
      <h3 class="dashboard-stats__title">
        <span appCountTo countFrom="0" [countTo]="value" (countToChange)="countToValue = $event">
          <ng-container *ngIf="!showAsDuration">{{countToValue | number:'1.0-0'}}</ng-container>
          <ng-container *ngIf="showAsDuration">{{countToValue | duration}}</ng-container>
        </span>
        <small>{{title}}</small>
      </h3>
    </div>
  `,
    standalone: true,
    imports: [NgClass, CountToDirective, NgIf, DecimalPipe, DurationPipe]
})
export class DashboardCardComponent implements OnInit, OnDestroy {

  @Input() public backgroundColor: string;
  @Input() public secondIconClass: string;
  @Input() public title: string;
  @Input() public value: number;
  @Input() public showAsDuration = false;

  @Input() selectedFilterType = {action: 99, text: 'Total Calls'};
  @Input() filterType = -1;

  @Output() onClick = new EventEmitter<number>();

  public countToValue = 0;

  constructor() {
  }

  onCubicClick($event) {
    if (this.onClick) {
      this.onClick.emit(this.filterType);
    }
  }

  ngOnInit() {
    console.log('init: ' + DashboardCardComponent.name);
  }

  ngOnDestroy() {
    console.log('destroy: ' + DashboardCardComponent.name);
  }

}
